// extracted by mini-css-extract-plugin
export default {"container":"page-loader_container__TYnzo","loader":"page-loader_loader__g1nLI"};